import axios from "axios";
const base_url = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_X_API_KEY;

const headers = {
  "X-API-KEY": apiKey
}

async function VerifyImageExistsSelfie(identification) {
  const data = {
    fileName: `selfie_${identification}`
  }
  try {
    return await axios.post(base_url + "/face-recognition/verifyImageExists/selfie", data, {
      headers: headers,
    });
  } catch (error) {
    throw error;
  }
}

async function VerifyImageExistsIdentification(identification) {
  try {
    const data = {
      fileName: `identification_${identification}`
    }
    return await axios.post(base_url + "/face-recognition/verifyImageExists/identification", data, {
      headers,
    });
  } catch (error) {
    throw error;
  }
}

async function GenerateSignedUrlCSSelfie(identification) {
  const data = {
    fileName: `selfie_${identification}.png`
  }
  try {
    return await axios.post(base_url + "/face-recognition/generateSignedUrlCS/selfie", data, {
      headers: headers,
    });
  } catch (error) {
    throw error;
  }
}

async function GenerateSignedUrlCSIdentification(identification) {
  try {
    const data = {
      fileName: `identification_${identification}.png`
    }
    return await axios.post(base_url + "/face-recognition/generateSignedUrlCS/identification", data, {
      headers,
    });
  } catch (error) {
    throw error;
  }
}

async function SendImageWithSignedUrl(url, image) {
  const blob = await (await fetch(image)).blob();
  try {
    return await axios.put(url, blob, {
      headers: {
        'Content-Type': 'image/png'
      },
    });
  } catch (error) {
    throw error;
  }
}

async function FaceRecognitionValidation(documentType, identification, step) {
  try {
    return await axios.get(base_url + "/face-recognition/verification", {
      params: {
        documentId: identification,
        documentType: documentType,
        step
      },
      headers,
    });
  } catch (error) {
    console.error(error)
    throw error;
  }
}

export {
  VerifyImageExistsSelfie,
  VerifyImageExistsIdentification,
  GenerateSignedUrlCSSelfie,
  GenerateSignedUrlCSIdentification,
  SendImageWithSignedUrl,
  FaceRecognitionValidation
}

